import styled from "styled-components";
import { AreaButton } from "@/main/components/shared/styles";
import { FormControlLabel } from "@mui/material";

export const Container = styled.div`
	display: grid;
	grid-template-columns: 1fr 120px;
	align-items: center;
	grid-template-areas:
		"areaStatus stickyButton"
		"boxFilters boxFilters"
		"grid grid";

	> *:nth-child(1) {
		grid-area: areaStatus;
		position: relative;
	}
	> *:nth-child(2) {
		grid-area: stickyButton;
		height: fit-content;
	}

	> *:nth-child(3) {
		grid-area: boxFilters;
	}

	> *:nth-child(4) {
		grid-area: grid;
	}

	> *:nth-child(1)::after {
		content: "";
		position: absolute;
		top: 0;
		right: -120px;
		bottom: 0;
		left: 0;
		background-color: #fff;
		border-radius: 1rem;
		z-index: -1;
	}

	> ${AreaButton} {
		margin: 0;
	}

	@media (max-width: 560px) {
		grid-template-columns: 1fr;
		justify-items: end;
		grid-template-areas:
			"areaStatus"
			"stickyButton"
			"boxFilters"
			"grid";

		> *:nth-child(1)::after {
			right: 0;
		}
	}
`;

export const CardArea = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: flex-start;
	flex-wrap: wrap;
	gap: 1rem;

	padding: 1rem;

	background: #ffffff;

	@media (max-width: 560px) {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		justify-items: center;
		padding: 0;
		width: 80%;
	}
`;

export const Row = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;
	margin-bottom: 1rem;

	@media (max-width: 560px) {
		grid-template-columns: 1fr;
	}
`;
export const PredefinedSearchLabel = styled(FormControlLabel)`
	width: 100%;
	height: 40px;
	margin: 0;

	&& .MuiFormControlLabel-label {
		white-space: nowrap;
	}
`;
export const AutoCompleteWrapper = styled.div`
	position: relative;
	height: 40px;
`;
